import { API_BASE_URL } from "@/config";
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'RefugeeForm',
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
              refugee_number: ''
            },
            error: '',
            json_data: {}
        };
    },
    emits: ['service_status_complete'],
    methods: {
        handle_submit() {
          if (!this.form.refugee_number) {
              this.showError('Error', 'Refugee number is required');
              return;
          }

          const refugee_number_pattern = /^[A-Za-z0-9]+$/;
          if (!refugee_number_pattern.test(this.form.refugee_number)) {
              this.showError('Error', 'Refugee number format is invalid');
              return;
          }

            const TOKEN = localStorage.getItem('token');
            const REFUGEE_VERIFICATION_API = `${API_BASE_URL}/verify_api/instant_verify_api/verify_refugee/`;

            this.error = '';

            $.ajax({
                url: REFUGEE_VERIFICATION_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    refugee_number: this.form.refugee_number
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    this.showSuccess('Successful', 'Refugee verification ran successfully', 3000);
                    this.$emit('service_status_complete');
                    this.form.refugee_number = '';
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    this.showError('Error', error_message);
                }
            });
        }
    }
};
